/**
 * Generique call to legacy back with the get method
 * @param {object} params request parameter object in url
 * 
 * @return {promise}
 */
export const callGetLegacyRoute = (params = {}) => {
    return new Promise((resolve, reject) => {
        SellsyJS.WebServiceCaller.get(`/`, params, 
            res => resolve(res),
            err => reject(err.response.data.error.message)
        );
    }) 
};